"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const react_i18next_1 = require("react-i18next");
const react_router_1 = require("react-router");
const Button_1 = __importDefault(require("../input/Button"));
const Auth_1 = require("../../actions/Auth");
const getStatusMessage = (status) => {
    switch (status) {
        case 'Loading':
            return 'auth:ConfirmationTokenLoading';
        case 'Confirming':
            return 'auth:ConfirmationTokenConfirming';
        case 'Confirmed':
            return 'auth:ConfirmationTokenConfirmed';
        case 'NotFound':
            return 'auth:ConfirmationTokenNotFound';
        case 'MissingToken':
            return 'auth:ConfirmationTokenMissing';
        default:
            return 'auth:ConfirmationTokenError';
    }
};
const VerifyPage = () => {
    const { t } = (0, react_i18next_1.useTranslation)('auth');
    const dispatch = (0, react_redux_1.useDispatch)();
    const { token } = (0, react_router_1.useParams)();
    const [status, setStatus] = react_1.default.useState('Loading');
    const [email, setEmail] = react_1.default.useState(undefined);
    const tokenVerified = react_1.default.useCallback((response) => {
        if (response &&
            (response.status === 'Confirmed' || response.status === 'NotFound' || response.status === 'Error')) {
            setStatus(response.status);
        }
        else {
            setStatus('Error');
        }
    }, []);
    const tokenInfoLoaded = react_1.default.useCallback((response) => {
        if (response && response.status === 'Found' && response.email) {
            setEmail(response.email);
            setStatus('Ready');
        }
        else if (response && response.status === 'NotFound') {
            setEmail(undefined);
            setStatus('NotFound');
        }
        else {
            setEmail(undefined);
            setStatus('Error');
        }
    }, []);
    react_1.default.useEffect(() => {
        if (token) {
            dispatch((0, Auth_1.startGetConfirmUserInfo)({ token }, tokenInfoLoaded));
        }
        else {
            setStatus('MissingToken');
        }
    }, [dispatch, token, tokenInfoLoaded]);
    const confirmUser = react_1.default.useCallback(() => {
        if (token) {
            setStatus('Confirming');
            dispatch((0, Auth_1.startConfirmUser)({ token }, tokenVerified));
        }
    }, [dispatch, token, tokenVerified]);
    const statusMessage = getStatusMessage(status);
    return (react_1.default.createElement("div", { className: "apptr__form apptr__form-auth apptr__form__label-standalone" },
        status !== 'Ready' && react_1.default.createElement("p", { className: "apptr__form__label-standalone" }, t(statusMessage)),
        status === 'Ready' && email && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("p", { className: "apptr__form__label-standalone" }, t('auth:ConfirmationTokenBelongsTo')),
            react_1.default.createElement("p", { className: "apptr__form__label-standalone", style: { textAlign: 'center' } },
                react_1.default.createElement("strong", null, email)),
            react_1.default.createElement("p", { className: "apptr__form__label-standalone" }, t('auth:ConfirmationTokenAskToConfirm')),
            react_1.default.createElement("p", { className: "apptr__form__label-standalone" },
                react_1.default.createElement(Button_1.default, { type: "button", onClick: confirmUser, label: t('auth:Confirm'), style: { display: 'inline-block' } })))),
        status !== 'Loading' && (react_1.default.createElement("p", { className: "apptr__form__label-standalone" },
            react_1.default.createElement(react_router_1.Link, { to: "/" }, t('auth:BackToHomePage'))))));
};
exports.default = VerifyPage;
//# sourceMappingURL=VerifyPage.js.map